import React from "react";

const About = ()=>{
    return (
        <h2>这是关于</h2>
    );
}

export default About;